module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'mpegg2v0',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
